
import { defineComponent, reactive } from 'vue'
import { BaseLineConfig, ConfigItem } from './LinuxBaseLineConfig'
import { useRoute } from 'vue-router'
import { useHelpBody } from '@/views/help/use-help-body'
export default defineComponent({
  setup (props, context) {
    const route = useRoute()
    const data = reactive({
      qid: (route.query.qid as string)?.split(','),
      config: treeToArray(BaseLineConfig)
    })
    function treeToArray (configs: ConfigItem[]) {
      let tem :ConfigItem[] = []
      configs.forEach((record) => {
        tem.push(record)
        if (record.children && record.children.length > 0) {
          const children = treeToArray(record.children)
          tem = tem.concat(children)
          delete record.children
        }
      })
      return tem
    }
    function filterRecords (id: string) {
      const configArr:ConfigItem[] = []
      const seperatedQid = id.split('-')
      configArr.push(data.config.filter(record => record.id === seperatedQid[0])[0])
      if (seperatedQid[1]) {
        configArr.push(data.config.filter(
          record => record.id === (seperatedQid[0] + '-' + seperatedQid[1]))[0]
        )
      }
      if (seperatedQid[1] && seperatedQid[2]) {
        configArr.push(
          data.config.filter(record => record.id === (seperatedQid[0] + '-' + seperatedQid[1] + '-' + seperatedQid[2]))[0]
        )
      }
      return configArr.some((item:ConfigItem) => !item) ? [] : configArr
    }
    function findRecords () {
      const qid:string | (string | null)[] = (route.query.qid as string)?.split(',')
      if (qid) {
        if (Array.isArray(qid)) {
          const configs:ConfigItem[] = []
          qid.map(id => configs.push(...filterRecords(id as string)))
          const results = [...new Set<ConfigItem>(configs.filter((item:ConfigItem) => item))]
          if (results.length) {
            data.config = results
          }
        } else {
          data.config = filterRecords(qid)
        }
      }
    }
    findRecords()
    useHelpBody()
    return {
      data
    }
  }
})
